// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageSelectorContainer {
  position: fixed !important;
  top: 50% !important;
  left: 59%;
  transform: translate(-50%, -50%) !important;
  z-index: 9999 !important;
  background-color: #fff !important;
  padding: 20px !important;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3) !important;
  width: 80%;
}

.imageSelectorShow {
  opacity: 1;
  transform: 5s;
  transition: all;
}

.addMediaText {
  cursor: pointer;
}

.imageSelectorHide {
  display: none !important;
}

.background {
  height: 100vh;
  overflow-y: auto;
}

.imageGallery {
  height: 250px;
  border: 1px solid #f3f3f3 !important;
  overflow: auto;
}

.onFileUpload {
  opacity: 0;
  border: 15px;
  height: 350px;
  width: 350px;
  padding: 0;
  margin: 0;
  left: 4%;
  top: 29%;
  cursor: pointer;
}

.onFileUploadContainerShow {
  /* display: block;
    top: 150px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center; */
  position: absolute;
}

.onFileUploadContainerHide {
  display: none;
}

.onFileUploadIcon {
  font-size: 30px;
  cursor: pointer;
  /* position: absolute; */
  top: -45px;
  left: 75px;
}

.onFileUploadTextShow {
  /* position: absolute; */
  font-size: 12px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}

.onFileUploadTextHide {
  display: none;
  position: relative;
}

.SearchIcon {
  background-color: #f3f3f3 !important;
  border-radius: none;
  width: 40px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.individualImage {
  height: 100px;
  width: 100%;
  object-fit: contain;
  border-radius: 10px;
  cursor: pointer;
}

.individualImagepreview {
  height: 100px;
  width: 100px;
  border-radius: 10px;
}

.checkMarkEnable {
  display: block;
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 20px;
  background-color: #41d141;
  color: white;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  margin: auto;
  padding-left: 5px;
}

.checkMarkDisable {
  display: none;
}

.closeMarkEnable {
  display: block;
  position: absolute;
  top: 5px;
  right: 30px;
  font-size: 10px;
  background-color: #000000;
  color: rgb(255, 255, 255);
  border-radius: 100%;
  height: 20px;
  width: 20px;
  margin: auto;
  display: flex;
  margin: auto;
  align-items: center;
  padding-left: 7px;
  cursor: pointer;
}

.closeMarkDisable {
  display: none;
  cursor: pointer;
}

.UploadButton {
  margin-top: 15px;
  border-radius: 5px;
  padding: 5px;
  color: #ffffff;
  background-color: var(--admin-color);
  border-color: var(--admin-color);
}

.closeIcon {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 15px;
  cursor: pointer;
}

.closeIcon:hover {
  color: red;
}

.imageGalleryTitle {
  background-color: #f3f3f3;
  padding: 10px;
  text-align: center;
  border: none;
}

button {
  transition: all 0.2s ease-out;
}

button:active {
  transform: scale(0.95);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.SearchIcon .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  margin-top: 25%;
}

.selectedFilesText {
  color: #868686 !important;
  padding: 0px 15px !important;
  font-size: 13px;
}

.ImagepreviewWrapperHide {
  height: 0px;
}

.Imagepreviewtitle {
  font-size: 10px;
}

.addMedia {
  height: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.addBlogMedia {
  height: 200px;
  width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.addMediaSection {
  height: 100px;
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
}

.addMediaSection img {
  height: 80px;
  object-fit: contain;
  border-radius: 10px;
}

.circleAddIconInProfile {
  position: absolute !important;
  top: 65px !important;
  right: 20px !important;
  cursor: pointer !important;
  font-size: 20px !important;
  color: #05bbc9 !important;
}

.addMediaWrapper {
  border-radius: 10px;
  border: 1px dashed;
  margin: 5%;
}

.notacceptMultipleFiles {
  border-radius: 10px;
  border: 1px dashed;
}
.portraitImageBlock {
  border-radius: 10px;
  border: 1px dashed;
  height: 260px;
  width: 200px;
  object-fit: fill;
  display: flex;
  justify-content: center;
  align-items: center;
}

.landScapeImageBlock {
  border-radius: 10px;
  border: 1px dashed;
  height: 160px;
  width: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.featuredImageBlock {
  border-radius: 10px;
  border: 1px dashed;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 260px;
}

.featuredImage {
  border-radius: 10px;
  border: 1px dashed;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 260px;
}

.image-container {
  position: relative;
  display: block;
  height: 100px;
  width: 107px;
  padding: 5px;
}

.blog-image-container {
  position: relative;
  display: block;
  height: 200px;
  width: 214px;
  padding: 5px;
}

.featuredDeleteImage {
  top: 5px;
  position: absolute;
  /* height: 250px; */
  height: 100%;
  width: 100%;
  border-radius: 10px;
  opacity: 0.8;
}

.featuredDeleteImage:hover {
  top: 5px;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #e1fdff;
  border-radius: 10px;
  opacity: 0.9;
  transition: 0.3s;
}

.deleteImage {
  top: 5px;
  position: absolute;
  height: 60px;
  width: 60px;
  border-radius: 10px;
  opacity: 0.8;
  cursor: pointer;
}

.deleteImage:hover {
  top: 5px;
  position: absolute;
  height: 50px;
  width: 50px;
  background-color: #e1fdff;
  border-radius: 10px;
  opacity: 0.9;
  transition: 0.3s;
}

.featuredDeleteImage .trashIconShow {
  opacity: 0;
  height: 100%;
  width: 100%;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  cursor: pointer;
}

.trashIconShow {
  opacity: 0;
  /* height: 80px; */
  width: 80px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  cursor: pointer;
}

.featuredDeleteImage .trashIconShow:hover {
  opacity: 1;
  transition: 0.3s;
  height: 100%;
  width: 240px;
  color: white;
}

.trashIconShow:hover {
  opacity: 1;
  transition: 0.3s;
  height: 60px;
  width: 60px;
  color: white;
}

.cancel-button {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 10px;
  background-color: transparent;
  border: none;
  color: #ffff;
  cursor: pointer;
  width: 15px;
  height: 15px;
  background: var(--admin-color);
  border-radius: 50%;
}

.cancel-button:hover {
  background-color: #ff0000;
}

.image-container img, .blog-image-container img{
  height: 100%;
  width: 100%;
  object-fit: contain;
  border-radius: 10px;
}

.SearchGroup {
  position: relative;
  display: flex;
}

.SearchBox {
  border: 1px solid #f3f3f3 !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.closePopup {
  position: absolute;
  top: 0px;
  right: 2px;
  font-size: 10px;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: auto;
}

.groupImages {
  position: relative;
  display: inline-block;
  height: 150px;
  width: 150px;
}

.groupImages .imageName {
  font-size: 13px !important;
}

.radioButton {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 15px !important;
}

.add_icon {
  height: 70px;
  width: 96%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
}

.primary_image_select {
  border: 3px solid #05bbc9;
  padding: 5px;
}

.primary_image_text {
  font-size: 8px;
  margin: 3px;
}

.checkbox {
  cursor: pointer;
}

.add_icon_single_image {
  height: 70px;
  width: 96%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.featuredDeleteImage .trashIconShow i {
  font-size: 50px;
  font-weight: 400;
  color: rgb(132, 132, 132);
  margin: auto;
  stroke-width: 10px;
}

.featuredDeleteImage .trashIconShow .mdi-window-close:hover {
  color: #ff6b6b;
}

.deleteImage .trashIconShow i {
  font-size: 25px;
  color: rgb(132, 132, 132);
  margin: 6px;
}

.deleteImage .trashIconShow .mdi-window-close:hover {
  color: #ff6b6b;
}

.landScape-image-container {
  position: relative;
  display: block;
  height: 160px;
  width: 260px; 
  padding: 5px;
}

.landScape-image-container img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  justify-items: center;
}

.portrait-image-container {
  position: relative;
  display: block;
  width: 190px;
  height: 260px; 
  padding: 5px;
}

.portrait-image-container img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  justify-items: center;
}

.single-image-container {
  position: relative;
  display: block;
  /* height: 250px; */
  /* width: 250px; */
  height: 90%;
  width: 90%;
  padding: 5px;
  margin: auto;
}

.single-image-container img {
  height: 100%;
  width: 100%;
  max-height: 250px;
  max-width: 250px;
  object-fit: contain;
  border-radius: 10px;
}


.gallery-image-container {
  position: relative;
  display: block;
  height: 60px;
  border: 1px solid #ced4da;
  border-radius: 10px;
  width: 60px;
  padding: 5px;
  margin-right: 5px;
}

.gallery-image-container img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  border-radius: 10px;

}

.deleteSingleImage {
  top: 5px;
  position: absolute;
  height: 100px;
  width: 100px;
  border-radius: 10px;
  opacity: 0.8;
}

.deleteSingleImage:hover {
  top: 5px;
  position: absolute;
  height: 90px;
  width: 88x;
  background-color: #e1fdff;
  border-radius: 10px;
  opacity: 0.9;
  transition: 0.3s;
}

.deleteSingleImage .trashIconShow {
  opacity: 0;
  height: 240px;
  width: 240px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}

.deleteSingleImage .trashIconShow {
  opacity: 0;
  height: 90px;
  width: 90px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}

.deleteSingleImage .trashIconShow:hover {
  opacity: 1;
  transition: 0.3s;
  height: 90px;
  width: 90px;
  color: white;
}

.deleteSingleImage .trashIconShow:hover {
  opacity: 1;
  transition: 0.3s;
  height: 90px;
  width: 90px;
  color: white;
}

.deleteSingleImage .trashIconShow i {
  font-size: 30px;
  color: rgb(132, 132, 132);
  margin: 28px;
}

.deleteSingleImage .trashIconShow .mdi-window-close:hover {
  color: #ff6b6b;
}

.store_name_as_logo {
  width: 75px;
  height: 75px;
  background-color: #ececec;
  color: #9d9d9d;
  font-size: 30px;
  text-align: center;
  line-height: 50px;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close_popUp {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.close_popUp:hover {
  color: #ff0000;
}

.Imageupload {
  position: relative;
}

.image_upload_condition {
  font-size: 12px;
}

.multiple_image_upload {
  border: 1px dashed;
  margin: 10px;
  border-radius: 15px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.multiple_image_upload:hover {
  background-color: #fbfbfb;
}

.display_mutiple_images {
  width: 320px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  height: 290px;
  overflow: auto;
}

.display_mutiple_images::-webkit-scrollbar {
  width: 4px;
  height: 20px;
}

.display_mutiple_images::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.display_mutiple_images::-webkit-scrollbar-thumb {
  background-color: #888;
  height: 50px;
  /* Adjust the height of the scrollbar thumb */
}

.display_mutiple_images::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.display_mutiple_images::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

.display_mutiple_images::-webkit-scrollbar-thumb:vertical {
  border-radius: 10px;
}

.display_mutiple_images::-webkit-scrollbar-thumb:horizontal {
  border-radius: 10px;
}

.display_mutiple_images::-webkit-scrollbar-thumb:vertical:active {
  background-color: #555;
}

.display_mutiple_images::-webkit-scrollbar-thumb:horizontal:active {
  background-color: #555;
}

.display_mutiple_images_closeIcon_wrapper {
  position: relative;
  top: -55px;
  cursor: pointer;
}

.display_mutiple_images_closeIcon_wrapper:hover {
  color: #ff0000;
}

.display_mutiple_images img {
  height: 125px;
  width: 125px;
  object-fit: contain;
  border-radius: 10px;
  margin: 5px;
  position: relative;
}

.display_mutiple_images_wrapper {
  margin: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.individualImage:hover {
  transform: scale(1.1);
}

.image_gallery_is_empty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30vh;
}

.image_gallery_is_empty:hover {
  color: var(--admin-color);
}

.image_selector_Pagination {
  margin: 5px;
}

.image_gallery_is_empty {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 30vh;
}

.image_upload_progress_bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image_upload_progress_bar span {
  color: #41d141;
}

.single-image {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.print-image {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  height: 150px;
}

.onFileUploadTextContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.onFileUploadTextShow {
  text-align: center;
  cursor: pointer;
}

/* Add any additional styling you want */`, "",{"version":3,"sources":["webpack://./src/Components/ImageSelector/ImageSelector.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,UAAU;EACV,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE;;;;;0BAKwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wCAAwC","sourcesContent":[".imageSelectorContainer {\n  position: fixed !important;\n  top: 50% !important;\n  left: 59%;\n  transform: translate(-50%, -50%) !important;\n  z-index: 9999 !important;\n  background-color: #fff !important;\n  padding: 20px !important;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3) !important;\n  width: 80%;\n}\n\n.imageSelectorShow {\n  opacity: 1;\n  transform: 5s;\n  transition: all;\n}\n\n.addMediaText {\n  cursor: pointer;\n}\n\n.imageSelectorHide {\n  display: none !important;\n}\n\n.background {\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.imageGallery {\n  height: 250px;\n  border: 1px solid #f3f3f3 !important;\n  overflow: auto;\n}\n\n.onFileUpload {\n  opacity: 0;\n  border: 15px;\n  height: 350px;\n  width: 350px;\n  padding: 0;\n  margin: 0;\n  left: 4%;\n  top: 29%;\n  cursor: pointer;\n}\n\n.onFileUploadContainerShow {\n  /* display: block;\n    top: 150px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center; */\n  position: absolute;\n}\n\n.onFileUploadContainerHide {\n  display: none;\n}\n\n.onFileUploadIcon {\n  font-size: 30px;\n  cursor: pointer;\n  /* position: absolute; */\n  top: -45px;\n  left: 75px;\n}\n\n.onFileUploadTextShow {\n  /* position: absolute; */\n  font-size: 12px;\n  display: flex;\n  flex-direction: column !important;\n  justify-content: center;\n  align-items: center;\n}\n\n.onFileUploadTextHide {\n  display: none;\n  position: relative;\n}\n\n.SearchIcon {\n  background-color: #f3f3f3 !important;\n  border-radius: none;\n  width: 40px;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.individualImage {\n  height: 100px;\n  width: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.individualImagepreview {\n  height: 100px;\n  width: 100px;\n  border-radius: 10px;\n}\n\n.checkMarkEnable {\n  display: block;\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  font-size: 20px;\n  background-color: #41d141;\n  color: white;\n  border-radius: 100%;\n  height: 30px;\n  width: 30px;\n  margin: auto;\n  padding-left: 5px;\n}\n\n.checkMarkDisable {\n  display: none;\n}\n\n.closeMarkEnable {\n  display: block;\n  position: absolute;\n  top: 5px;\n  right: 30px;\n  font-size: 10px;\n  background-color: #000000;\n  color: rgb(255, 255, 255);\n  border-radius: 100%;\n  height: 20px;\n  width: 20px;\n  margin: auto;\n  display: flex;\n  margin: auto;\n  align-items: center;\n  padding-left: 7px;\n  cursor: pointer;\n}\n\n.closeMarkDisable {\n  display: none;\n  cursor: pointer;\n}\n\n.UploadButton {\n  margin-top: 15px;\n  border-radius: 5px;\n  padding: 5px;\n  color: #ffffff;\n  background-color: var(--admin-color);\n  border-color: var(--admin-color);\n}\n\n.closeIcon {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.closeIcon:hover {\n  color: red;\n}\n\n.imageGalleryTitle {\n  background-color: #f3f3f3;\n  padding: 10px;\n  text-align: center;\n  border: none;\n}\n\nbutton {\n  transition: all 0.2s ease-out;\n}\n\nbutton:active {\n  transform: scale(0.95);\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n\n.SearchIcon .icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 50%;\n  margin-top: 25%;\n}\n\n.selectedFilesText {\n  color: #868686 !important;\n  padding: 0px 15px !important;\n  font-size: 13px;\n}\n\n.ImagepreviewWrapperHide {\n  height: 0px;\n}\n\n.Imagepreviewtitle {\n  font-size: 10px;\n}\n\n.addMedia {\n  height: 100px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.addBlogMedia {\n  height: 200px;\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.addMediaSection {\n  height: 100px;\n  width: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  /* align-items: center; */\n}\n\n.addMediaSection img {\n  height: 80px;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n.circleAddIconInProfile {\n  position: absolute !important;\n  top: 65px !important;\n  right: 20px !important;\n  cursor: pointer !important;\n  font-size: 20px !important;\n  color: #05bbc9 !important;\n}\n\n.addMediaWrapper {\n  border-radius: 10px;\n  border: 1px dashed;\n  margin: 5%;\n}\n\n.notacceptMultipleFiles {\n  border-radius: 10px;\n  border: 1px dashed;\n}\n.portraitImageBlock {\n  border-radius: 10px;\n  border: 1px dashed;\n  height: 260px;\n  width: 200px;\n  object-fit: fill;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.landScapeImageBlock {\n  border-radius: 10px;\n  border: 1px dashed;\n  height: 160px;\n  width: 260px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.featuredImageBlock {\n  border-radius: 10px;\n  border: 1px dashed;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 260px;\n}\n\n.featuredImage {\n  border-radius: 10px;\n  border: 1px dashed;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 260px;\n}\n\n.image-container {\n  position: relative;\n  display: block;\n  height: 100px;\n  width: 107px;\n  padding: 5px;\n}\n\n.blog-image-container {\n  position: relative;\n  display: block;\n  height: 200px;\n  width: 214px;\n  padding: 5px;\n}\n\n.featuredDeleteImage {\n  top: 5px;\n  position: absolute;\n  /* height: 250px; */\n  height: 100%;\n  width: 100%;\n  border-radius: 10px;\n  opacity: 0.8;\n}\n\n.featuredDeleteImage:hover {\n  top: 5px;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: #e1fdff;\n  border-radius: 10px;\n  opacity: 0.9;\n  transition: 0.3s;\n}\n\n.deleteImage {\n  top: 5px;\n  position: absolute;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px;\n  opacity: 0.8;\n  cursor: pointer;\n}\n\n.deleteImage:hover {\n  top: 5px;\n  position: absolute;\n  height: 50px;\n  width: 50px;\n  background-color: #e1fdff;\n  border-radius: 10px;\n  opacity: 0.9;\n  transition: 0.3s;\n}\n\n.featuredDeleteImage .trashIconShow {\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.trashIconShow {\n  opacity: 0;\n  /* height: 80px; */\n  width: 80px;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.featuredDeleteImage .trashIconShow:hover {\n  opacity: 1;\n  transition: 0.3s;\n  height: 100%;\n  width: 240px;\n  color: white;\n}\n\n.trashIconShow:hover {\n  opacity: 1;\n  transition: 0.3s;\n  height: 60px;\n  width: 60px;\n  color: white;\n}\n\n.cancel-button {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  font-size: 10px;\n  background-color: transparent;\n  border: none;\n  color: #ffff;\n  cursor: pointer;\n  width: 15px;\n  height: 15px;\n  background: var(--admin-color);\n  border-radius: 50%;\n}\n\n.cancel-button:hover {\n  background-color: #ff0000;\n}\n\n.image-container img, .blog-image-container img{\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n.SearchGroup {\n  position: relative;\n  display: flex;\n}\n\n.SearchBox {\n  border: 1px solid #f3f3f3 !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.closePopup {\n  position: absolute;\n  top: 0px;\n  right: 2px;\n  font-size: 10px;\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  margin: auto;\n}\n\n.groupImages {\n  position: relative;\n  display: inline-block;\n  height: 150px;\n  width: 150px;\n}\n\n.groupImages .imageName {\n  font-size: 13px !important;\n}\n\n.radioButton {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  margin-top: 15px !important;\n}\n\n.add_icon {\n  height: 70px;\n  width: 96%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.primary_image_select {\n  border: 3px solid #05bbc9;\n  padding: 5px;\n}\n\n.primary_image_text {\n  font-size: 8px;\n  margin: 3px;\n}\n\n.checkbox {\n  cursor: pointer;\n}\n\n.add_icon_single_image {\n  height: 70px;\n  width: 96%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.featuredDeleteImage .trashIconShow i {\n  font-size: 50px;\n  font-weight: 400;\n  color: rgb(132, 132, 132);\n  margin: auto;\n  stroke-width: 10px;\n}\n\n.featuredDeleteImage .trashIconShow .mdi-window-close:hover {\n  color: #ff6b6b;\n}\n\n.deleteImage .trashIconShow i {\n  font-size: 25px;\n  color: rgb(132, 132, 132);\n  margin: 6px;\n}\n\n.deleteImage .trashIconShow .mdi-window-close:hover {\n  color: #ff6b6b;\n}\n\n.landScape-image-container {\n  position: relative;\n  display: block;\n  height: 160px;\n  width: 260px; \n  padding: 5px;\n}\n\n.landScape-image-container img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  justify-items: center;\n}\n\n.portrait-image-container {\n  position: relative;\n  display: block;\n  width: 190px;\n  height: 260px; \n  padding: 5px;\n}\n\n.portrait-image-container img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  justify-items: center;\n}\n\n.single-image-container {\n  position: relative;\n  display: block;\n  /* height: 250px; */\n  /* width: 250px; */\n  height: 90%;\n  width: 90%;\n  padding: 5px;\n  margin: auto;\n}\n\n.single-image-container img {\n  height: 100%;\n  width: 100%;\n  max-height: 250px;\n  max-width: 250px;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n\n.gallery-image-container {\n  position: relative;\n  display: block;\n  height: 60px;\n  border: 1px solid #ced4da;\n  border-radius: 10px;\n  width: 60px;\n  padding: 5px;\n  margin-right: 5px;\n}\n\n.gallery-image-container img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n\n}\n\n.deleteSingleImage {\n  top: 5px;\n  position: absolute;\n  height: 100px;\n  width: 100px;\n  border-radius: 10px;\n  opacity: 0.8;\n}\n\n.deleteSingleImage:hover {\n  top: 5px;\n  position: absolute;\n  height: 90px;\n  width: 88x;\n  background-color: #e1fdff;\n  border-radius: 10px;\n  opacity: 0.9;\n  transition: 0.3s;\n}\n\n.deleteSingleImage .trashIconShow {\n  opacity: 0;\n  height: 240px;\n  width: 240px;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n}\n\n.deleteSingleImage .trashIconShow {\n  opacity: 0;\n  height: 90px;\n  width: 90px;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n}\n\n.deleteSingleImage .trashIconShow:hover {\n  opacity: 1;\n  transition: 0.3s;\n  height: 90px;\n  width: 90px;\n  color: white;\n}\n\n.deleteSingleImage .trashIconShow:hover {\n  opacity: 1;\n  transition: 0.3s;\n  height: 90px;\n  width: 90px;\n  color: white;\n}\n\n.deleteSingleImage .trashIconShow i {\n  font-size: 30px;\n  color: rgb(132, 132, 132);\n  margin: 28px;\n}\n\n.deleteSingleImage .trashIconShow .mdi-window-close:hover {\n  color: #ff6b6b;\n}\n\n.store_name_as_logo {\n  width: 75px;\n  height: 75px;\n  background-color: #ececec;\n  color: #9d9d9d;\n  font-size: 30px;\n  text-align: center;\n  line-height: 50px;\n  border-radius: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.close_popUp {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  cursor: pointer;\n}\n\n.close_popUp:hover {\n  color: #ff0000;\n}\n\n.Imageupload {\n  position: relative;\n}\n\n.image_upload_condition {\n  font-size: 12px;\n}\n\n.multiple_image_upload {\n  border: 1px dashed;\n  margin: 10px;\n  border-radius: 15px;\n  margin-top: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.multiple_image_upload:hover {\n  background-color: #fbfbfb;\n}\n\n.display_mutiple_images {\n  width: 320px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  height: 290px;\n  overflow: auto;\n}\n\n.display_mutiple_images::-webkit-scrollbar {\n  width: 4px;\n  height: 20px;\n}\n\n.display_mutiple_images::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.display_mutiple_images::-webkit-scrollbar-thumb {\n  background-color: #888;\n  height: 50px;\n  /* Adjust the height of the scrollbar thumb */\n}\n\n.display_mutiple_images::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n\n.display_mutiple_images::-webkit-scrollbar-corner {\n  background-color: #f1f1f1;\n}\n\n.display_mutiple_images::-webkit-scrollbar-thumb:vertical {\n  border-radius: 10px;\n}\n\n.display_mutiple_images::-webkit-scrollbar-thumb:horizontal {\n  border-radius: 10px;\n}\n\n.display_mutiple_images::-webkit-scrollbar-thumb:vertical:active {\n  background-color: #555;\n}\n\n.display_mutiple_images::-webkit-scrollbar-thumb:horizontal:active {\n  background-color: #555;\n}\n\n.display_mutiple_images_closeIcon_wrapper {\n  position: relative;\n  top: -55px;\n  cursor: pointer;\n}\n\n.display_mutiple_images_closeIcon_wrapper:hover {\n  color: #ff0000;\n}\n\n.display_mutiple_images img {\n  height: 125px;\n  width: 125px;\n  object-fit: contain;\n  border-radius: 10px;\n  margin: 5px;\n  position: relative;\n}\n\n.display_mutiple_images_wrapper {\n  margin: 5px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.individualImage:hover {\n  transform: scale(1.1);\n}\n\n.image_gallery_is_empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 30vh;\n}\n\n.image_gallery_is_empty:hover {\n  color: var(--admin-color);\n}\n\n.image_selector_Pagination {\n  margin: 5px;\n}\n\n.image_gallery_is_empty {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  height: 30vh;\n}\n\n.image_upload_progress_bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.image_upload_progress_bar span {\n  color: #41d141;\n}\n\n.single-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.print-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  height: 150px;\n}\n\n.onFileUploadTextContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.onFileUploadTextShow {\n  text-align: center;\n  cursor: pointer;\n}\n\n/* Add any additional styling you want */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
